<template>
	<page-container :page="page">
		<main-content
			:title="page.title || page.header"
			:subtitle="page.subtitle"
			:content="page.content"
			:booking-id="page.bookingID"
		/>

		<section class="main-content gallery-section background-light">
			<filter-buttons :items="categories" :filter="filter" @change-filter="filter = $event" />
			<image-grid :items="galleryFiltered" :filter="filter" @change-filter="filter = $event" />
		</section>

		<contentblocks
			v-if="page && page.contentblocks && page.contentblocks.length"
			:contentblocks="page.contentblocks"
			:content-blocks-content="page.sectionContentblocksContent"
			:content-blocks-subtitle="page.sectionContentblocksTitle"
		/>
		<frequently-asked-questions
			v-if="page && page.frequentlyAskedQuestion"
			:header="page.frequentlyAskedQuestion.header"
			:items="page.frequentlyAskedQuestion.faqitems"
		/>
		<pre-footer
			v-if="page && page.footerSection && page.footerSection.length"
			:footer-section="page.footerSection[0]"
		/>
		<newsletter
			v-if="page && page.showNewsletter"
			:header="defaults[locale].newsletter.title"
			:content="defaults[locale].newsletter.content"
			:button="defaults[locale].newsletter.button"
		/>
	</page-container>
</template>

<script setup>
import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox/fancybox.css';

const { page, fetchPage } = usePage();
const { defaults, fetchDefaults } = useDefaults();
const { locale } = useI18n();

await fetchPage();
await fetchDefaults();

const filter = ref('showAll');

const { data: gallery } = await useWebsiteFetch('gallery', {
	query: { language: locale.value },
	key: `${locale.value}/gallery`,
});

const categories = [
	...new Set(
		gallery.value
			.filter((item) => item.galleryCategorie)
			.map((item) => item.galleryCategorie && item.galleryCategorie.header),
	),
];

const galleryFiltered = computed(() => {
	if (filter.value === 'showAll') {
		return gallery.value;
	}

	return [...gallery.value].filter((item) => {
		if (!item.galleryCategorie) {
			return false;
		}

		return item.galleryCategorie.header === filter.value;
	});
});

onMounted(() => {
	Fancybox.bind('[data-fancybox]', {});
});
</script>
